<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-task"
      scrollable
      title="CADASTRO DE ATIVIDADES"
      size="lg"
    >
      <div class="form-group row mb-4">
        <div class="col-md-8 pt-2 pb-2">
          <label for="txtData"><small class="text-danger">*</small> Documento:</label>
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Nome do documento'"
              v-model="form.nome.value"
              :size="form.nome.maxlength"
              :required="form.nome.required"
              :state="form.nome.state"
              disabled>
            </b-form-input>
          </div>
        </div>
        <div class="col-md-4 pt-2">
          <label for="txtData"><small class="text-danger">*</small> Tipo de atividade:</label>
          <div class="input-group">
            <b-form-select v-model="form.tipoTarefaId.value" :options="form.tipoTarefaId.options" class="w-100">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-8 pt-2">
          <label for="txtData"><small class="text-danger">*</small> Responsável:</label>
          <div class="input-group">
            <b-form-select v-model="form.responsavelId.value" :options="form.responsavelId.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4 pt-2">
          <label> Data Limite / Lembrar em:</label>
          <NxDatePicker
            :placeholder="$lang.Common.DatePlaceholder"
            v-model="form.lembrarData.value"
            :required="form.lembrarData.required"
            :state="form.lembrarData.state"
          />
        </div>
        <div class="col-md-12 pt-3">
          <label for="txtData"> Observações:</label>
          <div class="input-group">
            <b-form-textarea
              v-model="form.observacao.value"
              :placeholder="'Digite uma breve descrição sobre a atividade'"
              :rows="form.observacao.rows"
              :maxlength="form.observacao.maxlength"
              :noResize="form.observacao.noResize"
            ></b-form-textarea>
          </div>
        </div>
        <div class="col-md-6 pt-3">
          <div class="col-md-12 pl-3">
            <b-form-checkbox v-model="form.realizado.value" :required="form.realizado.required" :state="form.realizado.state" switch>
              <template slot="default">A atividade ja foi concluída?</template>
            </b-form-checkbox>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-third btn-sm mr-2" v-b-tooltip.hover :title="'Salvar'" @click.prevent="onSave"><i class="fas fa-check-circle"></i><span class="d-md-down-none"> Salvar</span></button>
          <button type="button" class="btn btn-default btn-sm" v-b-tooltip.hover :title="'Fechar'" @click.prevent="hideModal"><i class="fas fa-times-circle"></i> Fechar</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { loading, toast } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'
import NxDatePicker from '@/components/forms/NxDatePicker.vue'
import Gedcompartilhamento from '@/shared/http/repositories/ged/gedcompartilhamento.js'
import GedTarefaRepository from '@/shared/http/repositories/ged/gedtarefa.js'
import GedTipoTaregaRepository from '@/shared/http/repositories/ged/gedtipotarefa.js'

import { JWTService } from '@/shared/services/jwt'

const menuForm = {
  nome: {
    value: '',
    maxlength: 100,
    required: true,
    state: null
  },
  realizado: {
    value: false,
    required: false,
    state: null
  },
  responsavelId: {
    value: '',
    maxlength: 100,
    required: true,
    state: null,
    options: []
  },
  observacao: {
    value: '',
    maxlength: 500,
    required: false,
    state: null,
    rows: 3
  },
  tipoTarefaId: {
    value: '',
    maxlength: 100,
    required: true,
    state: null,
    options: null
  },
  lembrarData: {
    value: '',
    required: false,
    state: null
  }
}
const menuModel = {
  id: null,
  gedId: null,
  nome: null,
  realizado: false,
  responsavelId: null,
  observacao: null,
  tipoTarefaId: null,
  lembrarData: null
}

export default {
  name: 'ModalTask',
  mixins: [ActionsForm],
  components: {
    NxDatePicker
  },
  data () {
    return {
      data: menuModel,
      form: menuForm,
      obj: null
    }
  },
  mounted () {
    this.onGetAllTipoTarefa()
  },
  methods: {
    showModal (obj) {
      this.onClear()
      this.$refs['modal-task'].show()
      this.obj = obj
      this.$nextTick(() => {
        this.onGetAllShared()
        this.onEdit()
      })
    },
    hideModal () {
      this.$refs['modal-task'].hide()
    },
    onEdit () {
      this.form.nome.value = this.obj.nome
      this.data.gedId = this.obj.id
    },
    onCreate () {
      if (this.data) {
        loading.push()
        this.data.lembrarData = this.form.lembrarData.value ? this.moment(this.form.lembrarData.value, 'DD/MM/YYYY').format('YYYY-MM-DD') : null
        this.data.tipoTarefaId = this.form.tipoTarefaId.value
        console.log(this.data)
        GedTarefaRepository.Create(this.data)
          .then((response) => {
            loading.pop()
            toast.success('Atividade cadastrada com sucesso!', 'CADASTRO DE ATIVIDADES')
            this.hideModal()
            this.$emit('Saved')
          })
          .catch(this.onException)
      }
    },
    onGetAllShared () {
      if (this.obj) {
        loading.push()
        Gedcompartilhamento.GetAllByMenu(this.obj.menu.id, 100, 0)
          .then((response) => {
            loading.pop()
            let listUsers = response.data.content
            if (listUsers) {
              this.form.responsavelId.options = listUsers.map((item) => {
                return { value: item.usuario.id, text: item.usuario.pessoa.nome.toUpperCase() }
              })
            }
            this.form.responsavelId.options.push({ value: JWTService.GetUserId(), text: JWTService.GetUserName().toUpperCase() + ' (Você)' })
            this.form.responsavelId.options.sort((a, b) => a.text.localeCompare(b.text))
          })
          .catch(this.onException)
      }
    },
    onGetAllTipoTarefa () {
      loading.push()
      GedTipoTaregaRepository.GetAllPaging(100, 0)
        .then((response) => {
          loading.pop()
          let listTipoTarefa = response.data.content
          if (listTipoTarefa) {
            this.form.tipoTarefaId.options = listTipoTarefa.map((item) => {
              return { value: item.id, text: item.nome.toUpperCase() }
            })
          }
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/ged/rightcontent/components/modaltask.vue